import { render, staticRenderFns } from "./AwardProgressTab.vue?vue&type=template&id=796e359e"
import script from "./AwardProgressTab.vue?vue&type=script&lang=js"
export * from "./AwardProgressTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports